import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { useParams } from 'react-router-dom';
import { fetchPartner } from '../../actions/partners';
import Module from '../../components/Module';
import ModuleContentList from '../../components/ModuleContentList';
import ContractsList from '../../components/ContractsList';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';

const PartnerDetail = () => {
  const dispatch = useDispatch();
  const { partnerAddress } = useParams();
  const partner = useSelector(state => get(state, `entities.partners.${partnerAddress}`, {}));
  const contracts = useSelector(state =>
    get(state, `entities.partners.${partnerAddress}.contracts`, []).map(contractAddress => {
      const contract = get(state, `entities.contracts.${contractAddress}`, {});
      contract.partner = { name: partner.name, address: partnerAddress };
      return contract;
    }),
  );

  useEffect(() => {
    dispatch(fetchPartner(partnerAddress, { useCache: false }));
  }, [dispatch, partnerAddress]);

  return (
    <>
      <PageTitle>{partner.name}</PageTitle>

      <Main>
        <Module>
          <ModuleContentList>
            <ContractsList
              shimmered
              enableShimmer={!contracts.length}
              items={contracts}
              noBorderBottom
            />
          </ModuleContentList>
        </Module>
      </Main>
    </>
  );
};

export default PartnerDetail;
